// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../index';

import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const CreateShapeEnquiryEngagementRingCollectionExistingCustomerDocument = `
    mutation createShapeEnquiryEngagementRingCollectionExistingCustomer($input: EnquiryEngagementRingCollectionInput!) {
  createEnquiryEngagementRingPreferAnotherShapeExistingCustomer(input: $input) {
    __typename
  }
}
    `;

export function useCreateShapeEnquiryEngagementRingCollectionExistingCustomerMutation() {
  return Urql.useMutation<SchemaTypes.CreateShapeEnquiryEngagementRingCollectionExistingCustomerMutation, SchemaTypes.CreateShapeEnquiryEngagementRingCollectionExistingCustomerMutationVariables>(CreateShapeEnquiryEngagementRingCollectionExistingCustomerDocument);
};